import ApiService from "@Src/services/ApiService";
import { CHECKOUT_API_ROUTES } from "./Checkout.api.constant";

export async function getStudentPlanDetails(planId: number) {
    return await ApiService.fetchData({
        url: `${CHECKOUT_API_ROUTES.GET_STUDENT_PLAN_DETAILS}?PlanId=${planId}`,
        method: 'GET'
    });
}

export async function submitCouponCode(couponCode: string) {
    return await ApiService.fetchData({
        url: CHECKOUT_API_ROUTES.SUBMIT_COUPON_CODE,
        method: 'POST',
        data: { couponCode }
    });
}

export async function subscribeStudentPlan(payload: any) {
    return await ApiService.fetchData({
        url: CHECKOUT_API_ROUTES.SUBSCRIBE_STUDENT_PLAN,
        method: 'POST',
        data: payload
    });
}

export async function subscribeStudentPlanPayment(payload: any) {
    return await ApiService.fetchData({
        url: CHECKOUT_API_ROUTES.SUBSCRIBE_STUDENT_PLAN_PAYMENT,
        method: 'POST',
        data: payload
    });
}
